@if (team) {
  <div class="planwrapper">
    <section class="program-section">
      <div class="section">
        <div>
          <span>Automated Bonuses</span>
        </div>
      </div>
      <table class="plans">
        @for (program of programSettings; track program) {
          <tr class="row">
            <td class="toggle"><mat-slide-toggle [checked]="program.enabled" (change)="toggleProgram($event, program)"></mat-slide-toggle></td>
            <td class="amount">{{program.amount | currency}}</td>
            <td class="programname">{{program.name}}</td>
            <td class="description">{{program.description}}</td>
            <td class="program-action"><button mat-raised-button color="accent" class="editbutton" [disabled]="!program.enabled" (click)="editProgram(program)">Edit</button></td>
          </tr>
        }
      </table>
    </section>
    <section class="program-section">
      <div class="section">
        <div>
          <span>Automated Bonus History</span>
        </div>
      </div>
      @if (historyItems.length === 0) {
        <span class="norows">No automatic bonuses have been paid</span>
      }
      @if (historyItems.length > 0) {
        <table class="history">
          <tr class="historyheader">
            <td class="firstheader">Sent To</td><td>Type</td><td>Amount</td><td [class.lastheader]="!canManageRewardClawbacks">Date Sent</td>@if (canManageRewardClawbacks) {
            <td class="lastheader"></td>
          }
        </tr>
        @for (historyItem of historyItems; track historyItem) {
          <tr>
            <td>{{historyItem.firstName}} {{historyItem.lastName}}</td>
            <td>
              <span>{{historyItem.type}}</span>
              @if (historyItem.clawedBackAt) {
                <span class="clawed-back-label">Clawed back</span>
              }
            </td>
            <td>{{historyItem.amount | currency}}</td>
            <td [class.lastcol]="!canManageRewardClawbacks">{{historyItem.createdAt | date}}</td>
            @if (canManageRewardClawbacks) {
              <td class="lastcol">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="automatedBonusMenu"
                  [matMenuTriggerData]="{historyItem: historyItem}"
                  [disabled]="!canClawbackProgramLog(historyItem) || clawbackInProgressId === historyItem.id"
                  aria-label="Automated bonus actions">
                  <mat-icon>more_vert</mat-icon>
                </button>
              </td>
            }
          </tr>
        }
      </table>
    }
    <mat-menu #automatedBonusMenu="matMenu">
      <ng-template matMenuContent let-historyItem="historyItem">
        <button mat-menu-item (click)="clawbackProgramLog(historyItem)">
          <span>Clawback</span>
        </button>
      </ng-template>
    </mat-menu>
  </section>
  <section class="program-section">
    <div class="section">
      <div class="sectionitems">
        <div>
          <span>Scheduled Rewards</span>
        </div>
        <button mat-raised-button color="accent" class="editbutton" (click)="removeAllRewards()">Remove All</button>
      </div>
    </div>
    @if (scheduledItems.length === 0) {
      <span class="norows">There are no pending scheduled rewards</span>
    }
    @if (scheduledItems.length > 0) {
      <table class="history">
        <tr class="historyheader">
          <td class="firstheader">Send on</td><td>Amount</td><td>Message</td><td class="lastheader">Recipient</td><td></td>
        </tr>
        @for (scheduledItem of scheduledItems; track scheduledItem) {
          <tr>
            <td>{{scheduledItem.date | date }}</td>
            <td>{{scheduledItem.amount | currency}}</td>
            @if (this.isAfterCurrentDate(scheduledItem.date)) {
              <td>{{scheduledItem.message}}</td>
            }
            @if (!this.isAfterCurrentDate(scheduledItem.date)) {
              <td class="failedpayment">Payment failed!</td>
            }
            <td>{{scheduledItem.email}}</td>
            <td class="lastcol"><button mat-raised-button color="accent" class="editbutton" (click)="removeItem(scheduledItem)">Remove</button></td>
          </tr>
        }
      </table>
    }
  </section>
  <section class="program-section">
    <div class="section">
      <div class="sectionitems">
        <div>
          <span>Rewards History</span>
        </div>
      </div>
    </div>
    @if (itemsSent.length === 0) {
      <span class="norows">There are no sent rewards</span>
    }
    @if (itemsSent.length > 0) {
      <table class="history">
        <tr class="historyheader">
          <td class="firstheader">Sent on</td><td>Amount</td><td>Message</td><td class="lastheader">Recipient</td><td></td>
        </tr>
        @for (reward of itemsSent; track reward) {
          <tr>
            <td>{{reward.dateSent | date}}</td>
            <td>{{reward.amount | currency}}</td>
            <td>{{reward.message}}</td>
            <td>{{reward.email}}</td>
            <td class="lastcol"><button mat-raised-button [ngStyle]="{opacity: 0}" [disabled]="true">Remove</button></td>
          </tr>
        }
      </table>
    }
  </section>
  <section class="program-section">
    <div class="section">
      <div class="sectionitems">
        <div>
          <span>One Time Rewards History</span>
        </div>
      </div>
    </div>
    @if (oneTimeRewards?.length === 0) {
      <span class="norows">There are no sent One Time Rewards</span>
    }
    @if (oneTimeRewards && oneTimeRewards.length > 0) {
      <table class="history">
        <tr class="historyheader">
          <td class="firstheader">Sent on</td>
          <td>Amount</td>
          <td>Message</td>
          <td class="lastheader">Recipient</td>
          <td></td>
        </tr>
        @for (reward of oneTimeRewards; track reward) {
          <tr>
            <td>{{ reward?.transactionDate ? (reward.transactionDate | date) : '---' }}</td>
            <td>{{ reward?.amount ?? '---' | currency}}</td>
            <td>{{ reward?.description ?? '---' }}</td>
            <td>{{ reward?.recipient ?? '---' }}</td>
            <td class="lastcol">
              <button mat-raised-button [ngStyle]="{opacity: 0}" [disabled]="true">Remove</button>
            </td>
          </tr>
        }
      </table>
    }
  </section>
</div>
}
